import { render, staticRenderFns } from "./ContestCriteriaComponent.vue?vue&type=template&id=e7e36986"
import script from "./ContestCriteriaComponent.vue?vue&type=script&lang=js"
export * from "./ContestCriteriaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports